//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'Skeleton',
    inheritAttrs: false,
    props: {
        skeletonProps: {
            type: Object,
            default: () => ({})
        },
        containerWidth: {
            type: [Number, String],
            default: 0
        },
        containerHeight: {
            type: [Number, String],
            default: 0
        }
    },
    computed: {
        clipId () {
            return this.uid();
        },
        gradientId () {
            return this.uid();
        },
        viewBox () {
            const { containerWidth, containerHeight } = this;

            return `0 0 ${containerWidth} ${containerHeight}`;
        }
    },
    methods: {
        uid () {
            return Math.random()
                .toString(36)
                .substring(2);
        }
    }
};
